import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    const url = orig.url || "";
    if (error.response?.status === 401 && !orig._retry && !url.startsWith("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Algo deu errado. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
  return fallback;
}

export const imgUrl = (src) => (src && src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src);
